var exports = {
  "container": "MediaTimeDisplay.module__container___Z19aVE",
  "time": "MediaTimeDisplay.module__time___Z19aVE",
  "separator": "MediaTimeDisplay.module__separator___Z19aVE",
  "small": "MediaTimeDisplay.module__small___Z19aVE",
  "medium": "MediaTimeDisplay.module__medium___Z19aVE",
  "large": "MediaTimeDisplay.module__large___Z19aVE",
  "compact": "MediaTimeDisplay.module__compact___Z19aVE",
  "duration": "MediaTimeDisplay.module__duration___Z19aVE",
};

__webpack_require__.r(module.exports = exports);
